import { EColors } from "common/styles";
import { Styled } from "components/Styled";
import styled from "styled-components";

export const StyledFooterTop = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding:34px 16px;
  border-top: 1px solid #333333;
  background: ${EColors.neutral_700};
  @media screen and (max-width: 767px) {
  gap:48px;
  }
  @media screen and (min-width: 768px) {
   flex-direction: row;
   justify-content: space-between;
   padding:34px 24px;
  }
   @media screen and (min-width: 1440px) {
   padding:34px 72px;
  }
`;
export const StyledFooterMenu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media screen and (min-width: 1440px) {
    flex-direction: row;
    gap: 40px;
  }
`;
export const FlexWrapperBrand = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
export const LogoImg = styled.img`
  width: 182px;
  height: 136px;
  @media screen and (max-width: 767px) {
    width: 142px;
    height: 107px;
  }
`;
export const StyledFooterBottom = styled.div`
  display: flex;
  flex-direction:column-reverse;
  justify-content: center;
  padding:16px;
  background: #333333;
  @media screen and (max-width: 767px) {
    gap:24px;
  }
  @media screen and (min-width: 768px) {
    justify-content: space-between;
    flex-direction:row;
    padding:16px 24px; 
  }
   @media screen and (min-width: 1440px) {
   padding:16px 72px; 
  }
`;

export const StyledFooter = styled.footer`
  width: 100%;
`;
